import React from "react";
import { CPInput } from "../CPInput";
import { CPDropdown } from "../CPDropdown";
import {
  MEASUREMENT_INPUT_UNITS,
  MEASUREMENT_RESULT_UNITS,
  convertMeasurementEntry,
  formatMeasurementDimensions,
  resolveMeasurementDimensions,
} from "../../helpers/measurementModel";

function NumberField({ label, value, onChange, step }) {
  const id = React.useId();
  return (
    <CPInput
      id={id}
      label={label}
      value={value}
      onChange={onChange}
      type="number"
      inputMode="decimal"
      step={step}
      min="0"
    />
  );
}

/**
 * Length and width for the existing measurement sheet.
 * Input unit controls how length and width are entered and shown.
 * Result unit controls only the calculated area.
 * Feet may be 0, and the inches field may be 12 or more.
 */
export function MeasurementDimensionFields({ form, onChange }) {
  function setField(field, value) {
    onChange({ [field]: value });
  }

  let preview = "";
  try {
    const resolved = resolveMeasurementDimensions(form);
    preview = formatMeasurementDimensions({
      length_in: resolved.lengthIn,
      width_in: resolved.widthIn,
      dimension_unit: resolved.dimensionUnit,
    });
  } catch {
    preview = "";
  }

  const inputUnit = form.entryUnit === "mm" ? "mm" : "ft-in";
  const resultUnit = form.areaUnit === "mm2" ? "mm2" : "ft2";

  return (
    <>
      <CPDropdown
        label="Input unit"
        value={inputUnit}
        onChange={(value) => onChange(convertMeasurementEntry(form, value))}
        options={MEASUREMENT_INPUT_UNITS}
      />

      <CPDropdown
        label="Result unit"
        value={resultUnit}
        onChange={(value) => onChange({ areaUnit: value })}
        options={MEASUREMENT_RESULT_UNITS}
      />

      {inputUnit === "mm" ? (
        <div className="est-sheet-field-row">
          <NumberField
            label="Length (mm)"
            value={form.lengthMm}
            onChange={(value) => setField("lengthMm", value)}
            step="0.1"
          />
          <NumberField
            label="Width (mm)"
            value={form.widthMm}
            onChange={(value) => setField("widthMm", value)}
            step="0.1"
          />
        </div>
      ) : (
        <>
          <div className="est-sheet-field-row">
            <NumberField
              label="Length (ft)"
              value={form.lengthFeet}
              onChange={(value) => setField("lengthFeet", value)}
              step="1"
            />
            <NumberField
              label="Length (in)"
              value={form.lengthInches}
              onChange={(value) => setField("lengthInches", value)}
              step="0.0001"
            />
          </div>
          <div className="est-sheet-field-row">
            <NumberField
              label="Width (ft)"
              value={form.widthFeet}
              onChange={(value) => setField("widthFeet", value)}
              step="1"
            />
            <NumberField
              label="Width (in)"
              value={form.widthInches}
              onChange={(value) => setField("widthInches", value)}
              step="0.0001"
            />
          </div>
        </>
      )}

      {preview ? <div className="est-row-meta">{preview}</div> : null}
    </>
  );
}
